import { render } from "./Transaction.vue?vue&type=template&id=486d8ee2&scoped=true"
import script from "./Transaction.vue?vue&type=script&lang=js"
export * from "./Transaction.vue?vue&type=script&lang=js"

import "./Transaction.vue?vue&type=style&index=0&id=486d8ee2&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-486d8ee2"

export default script